/* Lulubu Kids — interacciones de marca */
(function () {
  'use strict';

  /* ---------- carrito ---------- */
  async function addLines(lines) {
    const act = window.Shopify && window.Shopify.actions;
    if (act && act.updateCart) {
      const res = await act.updateCart({
        lines: lines.map((l) => ({
          merchandiseId: 'gid://shopify/ProductVariant/' + l.id,
          quantity: l.quantity || 1,
          attributes: l.properties ? Object.keys(l.properties).map((k) => ({ key: k, value: String(l.properties[k]) })) : undefined,
        })),
      });
      if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
      if (act.openCart) act.openCart();
      return res;
    }
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines.map((l) => ({ id: l.id, quantity: l.quantity || 1, properties: l.properties })) }),
    });
    if (!r.ok) throw new Error((await r.json()).description || 'No se pudo agregar');
    window.location.href = '/cart';
  }
  window.LulubuCart = { addLines };

  /* ---------- abrir el chat (Wizybot) desde cualquier enlace a #chat ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href="#chat"], a[href$="/#chat"], [data-lb-chat]');
    if (!a) return;
    e.preventDefault();
    const f = document.getElementById('WizybotShopifyWidget__iframe__outter__id');
    let btn = null;
    try { btn = f && f.contentDocument && f.contentDocument.querySelector('.WizybotShopifyWidget__open__button__inner'); } catch (err) {}
    if (btn) { if (!/__open/.test(f.className)) btn.click(); }
    else { window.location.href = '/pages/contact'; }
  });

  /* ---------- tarjetas ---------- */
  function cardState(card) {
    if (!card._lb) {
      let variants = [];
      try { variants = JSON.parse(card.querySelector('[data-lb-variants]').textContent); } catch (e) {}
      const sel = {};
      card.querySelectorAll('[data-lb-opt].is-on').forEach((b) => { sel[b.dataset.lbOpt] = b.dataset.value; });
      card._lb = { variants, sel };
    }
    return card._lb;
  }
  function paintAvail(card) {
    const st = cardState(card);
    card.querySelectorAll('[data-lb-opt]').forEach((b) => {
      const k = b.dataset.lbOpt;
      const ok = st.variants.some((v) => v.a && v.o[+k] === b.dataset.value && Object.keys(st.sel).every((j) => j === k || v.o[+j] === st.sel[j]));
      b.classList.toggle('is-off', !ok);
    });
  }
  function resolve(card) {
    const st = cardState(card);
    const keys = Object.keys(st.sel);
    const match = (v) => keys.every((k) => v.o[+k] === st.sel[k]);
    return st.variants.find((v) => match(v) && v.a) || st.variants.find(match) || null;
  }

  document.addEventListener('click', async (e) => {
    const opt = e.target.closest('[data-lb-card] [data-lb-opt]');
    if (opt && !opt.disabled) {
      const card = opt.closest('[data-lb-card]');
      const st = cardState(card);
      card.querySelectorAll('[data-lb-opt="' + opt.dataset.lbOpt + '"]').forEach((b) => b.classList.toggle('is-on', b === opt));
      st.sel[opt.dataset.lbOpt] = opt.dataset.value;
      paintAvail(card);
      const v = resolve(card);
      const msg = card.querySelector('[data-lb-msg]');
      if (msg) msg.textContent = v && !v.a ? 'Agotado en esta opción' : '';
      card.querySelectorAll('[data-lb-add]').forEach((b) => { if (v) b.dataset.variant = v.id; b.disabled = !!(v && !v.a); });
      return;
    }

    const add = e.target.closest('[data-lb-add]');
    if (!add) return;
    e.preventDefault();
    const card = add.closest('[data-lb-card]');
    let id = add.dataset.variant;
    if (card) {
      const st = cardState(card);
      const si = card.dataset.sizeIndex;
      const msg = card.querySelector('[data-lb-msg]');
      if (card.dataset.needsSize === 'true' && !(si in st.sel)) {
        if (msg) msg.textContent = 'Elige una talla';
        card.querySelector('.lb-card__opts')?.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' }, { transform: 'translateX(0)' }], { duration: 250 });
        return;
      }
      const v = resolve(card);
      if (v) id = v.id;
    }
    const label = add.textContent;
    add.disabled = true;
    add.textContent = 'Agregando…';
    try {
      await addLines([{ id: +id, quantity: +(add.dataset.qty || 1) }]);
      add.textContent = '✓ Agregado';
    } catch (err) {
      add.textContent = label;
      const msg = card && card.querySelector('[data-lb-msg]');
      if (msg) msg.textContent = err.message;
    }
    setTimeout(() => { add.textContent = label; add.disabled = false; }, 1600);
  });

  /* ---------- pestañas ---------- */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-lb-tab]');
    if (!tab) return;
    const root = tab.closest('[data-lb-tabs]');
    root.querySelectorAll('[data-lb-tab]').forEach((t) => {
      const on = t === tab;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on);
    });
    root.querySelectorAll('[data-lb-panel]').forEach((p) => { p.hidden = p.dataset.lbPanel !== tab.dataset.lbTab; });
  });

  /* ---------- selector de chips genérico (buscador de regalos) ---------- */
  document.addEventListener('click', (e) => {
    const c = e.target.closest('[data-lb-pick]');
    if (!c) return;
    const group = c.closest('[data-lb-group]');
    group.querySelectorAll('[data-lb-pick]').forEach((b) => b.classList.toggle('is-on', b === c));
    const form = c.closest('[data-lb-finder]');
    if (form) updateFinder(form);
  });
  function updateFinder(form) {
    const val = (g) => form.querySelector('[data-lb-group="' + g + '"] .is-on');
    const who = val('who'), budget = val('budget');
    let url = (who && who.dataset.url) || form.dataset.defaultUrl || '/collections/all';
    const params = [];
    if (budget && budget.dataset.min) params.push('filter.v.price.gte=' + budget.dataset.min);
    if (budget && budget.dataset.max) params.push('filter.v.price.lte=' + budget.dataset.max);
    const cta = form.querySelector('[data-lb-finder-cta]');
    if (cta) {
      cta.href = url + (params.length ? '?' + params.join('&') : '');
      const t = cta.querySelector('[data-lb-finder-label]');
      if (t && who) t.textContent = who.dataset.label || who.textContent.trim().toLowerCase();
    }
  }
  document.querySelectorAll('[data-lb-finder]').forEach(updateFinder);

  /* ---------- cuenta regresiva ---------- */
  function tick() {
    document.querySelectorAll('[data-lb-countdown]').forEach((el) => {
      const end = new Date(el.dataset.lbCountdown).getTime();
      let s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      const d = Math.floor(s / 86400); s -= d * 86400;
      const h = Math.floor(s / 3600); s -= h * 3600;
      const m = Math.floor(s / 60);
      const set = (k, v) => { const n = el.querySelector('[data-' + k + ']'); if (n) n.textContent = String(v).padStart(2, '0'); };
      set('d', d); set('h', h); set('m', m);
      if (end <= Date.now() && el.dataset.hideWhenDone !== undefined) el.hidden = true;
    });
  }
  tick();
  setInterval(tick, 30000);

  /* ---------- fecha estimada de llegada (días hábiles, festivos Colombia) ---------- */
  const HOLIDAYS = ['2026-01-01','2026-01-12','2026-03-23','2026-04-02','2026-04-03','2026-05-01','2026-05-18','2026-06-08','2026-06-15','2026-06-29','2026-07-20','2026-08-07','2026-08-17','2026-10-12','2026-11-02','2026-11-16','2026-12-08','2026-12-25',
    '2027-01-01','2027-01-11','2027-03-22','2027-03-25','2027-03-26','2027-05-01','2027-05-10','2027-05-31','2027-06-07','2027-07-05','2027-07-20','2027-08-07','2027-08-16','2027-10-18','2027-11-01','2027-11-15','2027-12-08','2027-12-25'];
  function addBusinessDays(date, n) {
    const d = new Date(date);
    let added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      const iso = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      if (d.getDay() !== 0 && d.getDay() !== 6 && HOLIDAYS.indexOf(iso) === -1) added++;
    }
    return d;
  }
  const MESES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  function fillEta(scope) {
    (scope || document).querySelectorAll('[data-lb-eta]:not([data-done])').forEach((el) => {
      const min = +(el.dataset.min || 8), max = +(el.dataset.max || 12);
      const a = addBusinessDays(new Date(), min), b = addBusinessDays(new Date(), max);
      el.textContent = a.getMonth() === b.getMonth()
        ? 'entre el ' + a.getDate() + ' y el ' + b.getDate() + ' de ' + MESES[b.getMonth()]
        : 'entre el ' + a.getDate() + ' de ' + MESES[a.getMonth()] + ' y el ' + b.getDate() + ' de ' + MESES[b.getMonth()];
      el.dataset.done = '1';
    });
  }
  fillEta();

  /* ---------- extras del carrito lateral ---------- */
  let decorating = false;
  async function decorateCart() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer || decorating) return;
    decorating = true;
    try {
      const items = drawer.querySelector('.cart-drawer__items');
      const summary = drawer.querySelector('.cart-drawer__summary');
      const tpl = (id) => document.getElementById(id);
      const empty = drawer.querySelector('.cart-drawer--empty');
      if (empty) { drawer.querySelectorAll('.lb-cup').forEach((n) => n.remove()); }
      if (!empty && items && !items.querySelector('.lb-cup') && tpl('lb-cart-upsell')) {
        items.appendChild(tpl('lb-cart-upsell').content.cloneNode(true));
        const cart = await fetch('/cart.js').then((r) => r.json());
        const inCart = cart.items.map((i) => String(i.variant_id));
        items.querySelectorAll('[data-lb-cup]').forEach((c) => { if (inCart.indexOf(c.dataset.lbCup) > -1) c.remove(); });
        const row = items.querySelector('.lb-cup__row');
        if (row && !row.children.length) items.querySelector('.lb-cup').remove();
      }
      if (summary && !summary.querySelector('.lb-ceta') && tpl('lb-cart-eta')) {
        let etaTpl = tpl('lb-cart-eta');
        if (tpl('lb-cart-eta-now')) {
          const c = await fetch('/cart.js').then((r) => r.json()).catch(() => null);
          if (c && c.items.length && c.items.every((i) => i.product_type === 'Halloween')) etaTpl = tpl('lb-cart-eta-now');
        }
        if (summary.querySelector('.lb-ceta')) return;
        summary.insertBefore(etaTpl.content.cloneNode(true), summary.firstChild);
        summary.appendChild(tpl('lb-cart-pay').content.cloneNode(true));
        fillEta(summary);
      }
    } finally { decorating = false; }
  }
  const drawerObs = new MutationObserver(() => { clearTimeout(drawerObs.t); drawerObs.t = setTimeout(decorateCart, 60); });
  function watchDrawer() {
    const d = document.getElementById('cart-drawer');
    if (d) { drawerObs.observe(d, { childList: true, subtree: true }); decorateCart(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer); else watchDrawer();
})();
